import React, { memo, useCallback } from "react";
import cn from "classnames";
import Skeleton from "react-loading-skeleton";

import { LabelProps } from "./Label.props";
import globalFormStyles from "../global.formElements.module.scss";
import styles from "./Label.module.scss";

/**
 * @deprecated
 */
const Label: React.FC<LabelProps> = ({
  id,
  label,
  disabled = false,
  isLoading = false,
  validate,
  useAsterisk,
}: LabelProps): JSX.Element => {
  const labelClasses = cn(globalFormStyles["label"], { disabled: disabled });
  const isRequired = validate?.required;

  const Asterisk = useCallback(() => {
    if (isRequired && useAsterisk) {
      return <sup className={styles["asterisk"]}>*</sup>;
    } else {
      return null;
    }
  }, [isRequired, useAsterisk]);

  const Optional = useCallback(() => {
    if (!isRequired && !useAsterisk) {
      return <span>Optional</span>;
    } else {
      return null;
    }
  }, [isRequired, useAsterisk]);

  let component = (
    <label aria-label={label} htmlFor={id} className={labelClasses} data-testid={`test__${id}-label`}>
      {label} <Optional /> <Asterisk />
    </label>
  );

  if (isLoading) {
    component = <Skeleton />;
  }

  return component;
};

/**
 * @deprecated
 */
export default memo(Label);
